import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Preview from "./Preview";

const LogisticRebidSubmission = () => {
  const { logisticDraftId } = useParams();

  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const vendorId = JSON.parse(localStorage.getItem("vendor"));

  const [rfq, setRfq] = useState(null);
  const [step, setStep] = useState(1);

  const [bid, setBid] = useState({
    lumpSumRate: "",
    remarks: "",
    attachment1: "",
    attachment1Filename: "",
    attachment2: "",
    attachment2Filename: "",
    attachment3: "",
    attachment3Filename: "",
  });

  const [items, setItems] = useState([]);
  const [previousQuote, setPreviousQuote] = useState(null);

  useEffect(() => {
    if (!vendorId || !logisticDraftId) return;

    const getRFQ = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/get-by-id?vendorId=${vendorId}&logisticDraftId=${logisticDraftId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );

        setRfq(res.data);

        const workItems = res.data.workItems || [];

        try {
          const quoteRes = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/logistic/quote?vendorId=${vendorId}&logisticDraftId=${logisticDraftId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setPreviousQuote(quoteRes.data || null);
        } catch (quoteError) {
          console.log("Previous logistic quote not found or could not be loaded.", quoteError);
        }

        const mappedItems = workItems.map((item) => ({
          ...item,
          newRate: "",
          rate: "",
          currency: "",
          exchangeRate: "",
          total: 0,
          remark: "",
        }));

        setItems(mappedItems);
      } catch (error) {
        console.log(error);
      }
    };

    getRFQ();
  }, [vendorId, logisticDraftId]);

  if (!rfq) {
    return <div style={{ padding: 40 }}>Loading...</div>;
  }

  return (
    <div style={{ position: "relative" }}>
      {step === 1 && (
        <Step1
          bid={bid}
          setBid={setBid}
          rfq={rfq}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}

      {step === 2 && (
        <Step2
          rfq={rfq}
          items={items}
          setItems={setItems}
          setStep={setStep}
          previousQuote={previousQuote}
        />
      )}

      {step === 3 && (
        <Preview
          rfq={rfq}
          bid={bid}
          items={items}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}
    </div>
  );
};

export default LogisticRebidSubmission;
